// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"89fc90a9","508":"74d1a4c9"}[chunkId] + ".chunk.js";
};